// ArchivedToDirectSale.jsx
import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  TextField,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  RadioGroup,
  FormControlLabel,
  Radio,
  IconButton,
  Snackbar,
  Alert,
  CircularProgress,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { db, storage } from "./firebase";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { apiFetch, API_BASE } from "./utils/apiClient";

import InvoiceModal from "./InvoiceModal";
import { getBoxEmployeeName } from "./utils/userProfile";
import UploadPreview, { appendPickedFiles } from "./components/UploadPreview";

// ✅ غيّر هذا إذا اسم كولكشن الأرشيف عندك مختلف
const ARCHIVE_COLLECTION = "archivedOrders";

export default function ArchivedToDirectSale() {
  const username = localStorage.getItem("username");

  // حسابات البوكسات (مثل تيهان) باسمها الظاهر أولاً، وإلا الأسماء الثابتة
  const employeeName =
    getBoxEmployeeName() ||
    (username === "rand@123"
      ? "رند"
      : username === "jumana@123"
      ? "جمانا"
      : username === "sara@123"
      ? "ساره"
      : username === "Baneen@123"
      ? "بنين"
      : username === "karina@123"
      ? "تيهان"
      : username === "maryam@123"
      ? "مريم"
      : username ==="maysa@123"
      ? "مياسة"
      : "");

  // ====== Lists ======
  const governorates = [
    "بغداد",
    "البصرة",
    "نينوى",
    "الأنبار",
    "ديالى",
    "كركوك",
    "واسط",
    "ميسان",
    "ذي قار",
    "بابل",
    "كربلاء",
    "النجف",
    "الديوانية",
    "المثنى",
    "صلاح الدين",
    "دهوك",
    "أربيل",
    "السليمانية",
  ];

  // ====== Archive list ======
  const [archivedOrders, setArchivedOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // ====== Dialog convert ======
  const [openConvert, setOpenConvert] = useState(false);
  const [selectedArchived, setSelectedArchived] = useState(null);

  // ====== Form fields for new direct sale ======
  const [customerName, setCustomerName] = useState("");
  const [governorate, setGovernorate] = useState("");
  const [price, setPrice] = useState("");
  const [source, setSource] = useState("");
  const [orderType, setOrderType] = useState("");
  const [otherCustomerType, setOtherCustomerType] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");

  const [boardsCount, setBoardsCount] = useState("");
  const [drawingBoardsCount, setDrawingBoardsCount] = useState("");

  const [withAssembly, setWithAssembly] = useState(null);
  const [withDrawing, setWithDrawing] = useState(null);

  const [note, setNote] = useState("");

  // ====== Invoice ======
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  // ====== Halima popup ======
  const [halimaOpen, setHalimaOpen] = useState(false);
  const [halimaNote, setHalimaNote] = useState("");
  const [halimaImages, setHalimaImages] = useState([]);
  const [halimaImageUrls, setHalimaImageUrls] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // ====== Submit ======
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ====== Load archived orders realtime ======
 useEffect(() => {
  if (!employeeName) return;

  const q = query(
    collection(db, ARCHIVE_COLLECTION),
    where("employee", "==", employeeName)
  );

  const unsub = onSnapshot(q, (snap) => {
    const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

    data.sort(
      (a, b) => (b.archivedAt?.seconds || 0) - (a.archivedAt?.seconds || 0)
    );

    setArchivedOrders(data);
  });

  return () => unsub();
}, [employeeName]);


 const filteredArchive = useMemo(() => {
  const q = searchTerm.trim().toLowerCase();

  // ✅ أخفي الطلبات اللي انتحولت بيع مباشر
  const base = archivedOrders.filter((o) => !o.convertedToDirectSale);

  if (!q) return base;

  return base.filter((o) => {
    const name = (o.customerName || "").toLowerCase();
    const emp = (o.employee || "").toLowerCase();
    return name.includes(q) || emp.includes(q);
  });
}, [archivedOrders, searchTerm]);

  // ===== Helpers =====
  const handlePriceChange = (e) => {
    const val = (e.target.value || "").replace(/,/g, "");
    if (/^\d*$/.test(val)) {
      const formatted = val ? Number(val).toLocaleString("en-US") : "";
      setPrice(formatted);
    }
  };

  const resetForm = () => {
    setCustomerName("");
    setGovernorate("");
    setPrice("");
    setSource("");
    setOrderType("");
    setOtherCustomerType("");
    setCustomerPhone("");

    setBoardsCount("");
    setDrawingBoardsCount("");

    setWithAssembly(null);
    setWithDrawing(null);

    setNote("");

    setInvoiceData(null);
    setIsInvoiceOpen(false);

    // halima
    setHalimaOpen(false);
    setHalimaNote("");
    setHalimaImages([]);
    setHalimaImageUrls([]);
    setUploading(false);
    setSnackbarOpen(false);

    setIsSubmitting(false);
  };

  const openConvertDialog = (archived) => {
    setSelectedArchived(archived);

    // ✅ افتراضي: نملأ الحقول من الأرشيف (وتقدر تغيّر)
    setCustomerName(archived.customerName || "");
    setGovernorate(archived.governorate || "");
    setPrice(
      archived.price != null
        ? Number(archived.price).toLocaleString("en-US")
        : ""
    );
    setSource(archived.source || "");
    setOrderType(archived.orderType || "");
    setOtherCustomerType("");
    setCustomerPhone(archived.customerPhone || "");

    setBoardsCount(archived.boardsCount ? String(archived.boardsCount) : "");
    setDrawingBoardsCount(
      archived.drawingBoardsCount ? String(archived.drawingBoardsCount) : ""
    );

    setWithAssembly(
      typeof archived.withAssembly === "boolean" ? archived.withAssembly : null
    );
    setWithDrawing(
      typeof archived.withDrawing === "boolean" ? archived.withDrawing : null
    );

    setNote(archived.note || "");

    setInvoiceData(archived.invoice || null);

    // halima reset
    setHalimaNote("");
    setHalimaImages([]);
    setHalimaImageUrls([]);

    setOpenConvert(true);
  };

  // ===== Upload to Halima (required if withDrawing) =====
  const handleUploadToHalima = async () => {
    if (!customerName || !governorate) {
      alert("يرجى إدخال اسم الزبون والمحافظة أولاً");
      return;
    }
    if (!halimaNote.trim()) {
      alert("⚠️ يجب إدخال ملاحظة للرسام قبل الإرسال");
      return;
    }
    if (halimaImages.length === 0) {
      alert("⚠️ لازم ترفع صورة واحدة على الأقل");
      return;
    }

    setUploading(true);
    try {
      const urls = [];
      for (const image of halimaImages) {
        const storageRef = ref(
          storage,
          `halimaDirect/${Date.now()}-${image.name}`
        );
        await uploadBytes(storageRef, image);
        const url = await getDownloadURL(storageRef);
        urls.push(url);
      }

      setHalimaImageUrls(urls);
      setSnackbarOpen(true);
      setHalimaOpen(false);
    } catch (error) {
      console.error("❌ فشل رفع صور الرسام:", error);
      alert("❌ حدث خطأ أثناء رفع الصور. الرجاء المحاولة مرة أخرى.");
    } finally {
      setUploading(false);
    }
  };

  // ===== Convert archived to direct sale =====
  const handleConvert = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      // ✅ validations (بيع مباشر: بدون رابط وبدون أولوية - حسب طلبك)
      if (!customerName || !governorate || !price || !source || !orderType) {
        alert("⚠️ يرجى ملء الحقول الأساسية: الاسم، المحافظة، السعر، المصدر، نوع الزبون");
        setIsSubmitting(false);
        return;
      }

      if (!boardsCount || Number(boardsCount) <= 0) {
        alert("⚠️ يرجى إدخال عدد اللوحات الكلي بشكل صحيح");
        setIsSubmitting(false);
        return;
      }

      if (withDrawing === null || withAssembly === null) {
        alert("⚠️ يرجى اختيار (مع/بدون) تركيب و (مع/بدون) رسم");
        setIsSubmitting(false);
        return;
      }

      // ✅ إذا مع رسم: لازم صور + ملاحظة لحليمة
      if (withDrawing === true && halimaImageUrls.length === 0) {
        alert("🔔 اخترت 'مع رسم' — لازم ترفع صور وملاحظة للرسام قبل تحويل الطلب.");
        setIsSubmitting(false);
        return;
      }

      if (withDrawing === true) {
        if (!drawingBoardsCount || Number(drawingBoardsCount) <= 0) {
          alert("⚠️ يرجى إدخال عدد لوحات الرسم بشكل صحيح");
          setIsSubmitting(false);
          return;
        }
      }

      const numericPrice = Number(String(price).replace(/,/g, "")) || 0;

      // status/isDirectSale/directSaleFromArchive/fromArchivedId/https/priority/
      // createdAt/history تُحسَب بالسيرفر (Phase 05F) - orderType (other_company)
      // يُحسَب بالسيرفر أيضاً بنفس منطق AddOrder/Phase 05B
      const res = await apiFetch(`${API_BASE}/orders/from-archive`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          archivedOrderId: selectedArchived?.id,
          customerName,
          governorate,
          price: numericPrice,
          createdByEmployee: employeeName,
          source,
          orderType,
          otherCustomerType,
          customerPhone: customerPhone || "",
          boardsCount: Number(boardsCount),
          drawingBoardsCount: withDrawing ? Number(drawingBoardsCount) : 0,
          withAssembly,
          withDrawing,
          note,
          invoice: invoiceData || null,
          halimaImageUrls: withDrawing ? halimaImageUrls || [] : undefined,
          halimaNote: withDrawing ? halimaNote || "" : undefined,
        }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || "فشل تحويل الطلب");
      }

      alert("✅ تم تحويل الطلب إلى بيع مباشر بنجاح");
      setOpenConvert(false);
      resetForm();
    } catch (err) {
      console.error("❌ convert error:", err);
      alert("❌ حدث خطأ أثناء التحويل");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }} dir="rtl">
      <Paper elevation={3} sx={{ p: 3, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={800} sx={{ mb: 2 }}>
          📦 الأرشيف → تحويل إلى بيع مباشر
        </Typography>

        <TextField
          fullWidth
          label="🔍 بحث (اسم الزبون أو الموظفة)"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
        />

        {filteredArchive.length === 0 ? (
          <Typography color="text.secondary">
            لا توجد طلبات مؤرشفة حالياً.
          </Typography>
        ) : (
          <Box>
            {filteredArchive.map((o) => (
              <Paper
                key={o.id}
                sx={{
                  p: 2,
                  mb: 1.5,
                  borderRadius: 2,
                  border: "1px solid #eee",
                }}
              >
                <Typography fontWeight={800}>
                  👤 {o.customerName || "—"}{" "}
                  <span style={{ color: "#666" }}>
                    | من: {o.employee || "—"}
                  </span>
                </Typography>
                <Typography fontWeight={700}>
                  🏙️ {o.governorate || "—"} | 💰{" "}
                  {o.price != null ? Number(o.price).toLocaleString() : "—"} د.ع
                </Typography>

                <Typography fontSize={13} color="text.secondary">
                  السبب/ملاحظة: {o.archiveReason || o.note || "—"}
                </Typography>

                <Box mt={1} display="flex" gap={1} flexWrap="wrap">
                <Button
  variant="contained"
  disabled={!!o.convertedToDirectSale}
  onClick={() => openConvertDialog(o)}
>
  {o.convertedToDirectSale ? "✅ تم التحويل" : "✅ تحويل إلى بيع مباشر"}
</Button>

                </Box>
              </Paper>
            ))}
          </Box>
        )}
      </Paper>

      {/* ================= Convert Dialog ================= */}
      <Dialog
        open={openConvert}
        onClose={() => {
          setOpenConvert(false);
          resetForm();
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          تحويل إلى بيع مباشر
          <IconButton
            aria-label="close"
            onClick={() => {
              setOpenConvert(false);
              resetForm();
            }}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Typography fontWeight={800} sx={{ mb: 2 }}>
            الطلب المؤرشف: {selectedArchived?.customerName || "—"}
          </Typography>

          <TextField
            fullWidth
            label="اسم الزبون"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
            sx={{ mb: 2 }}
            required
          />

          <FormControl fullWidth sx={{ mb: 2 }} required>
            <InputLabel>المحافظة</InputLabel>
            <Select
              value={governorate}
              label="المحافظة"
              onChange={(e) => setGovernorate(e.target.value)}
            >
              {governorates.map((gov) => (
                <MenuItem key={gov} value={gov}>
                  {gov}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="السعر (دينار عراقي)"
            value={price}
            onChange={handlePriceChange}
            sx={{ mb: 2 }}
            required
            inputProps={{ inputMode: "numeric" }}
          />

          <TextField
            fullWidth
            label="عدد اللوحات الكلي"
            type="number"
            value={boardsCount}
            onChange={(e) => setBoardsCount(e.target.value)}
            sx={{ mb: 2 }}
            required
            inputProps={{ min: 1, step: 1 }}
          />

          <FormControl fullWidth sx={{ mb: 2 }} required>
            <InputLabel>نوع الزبون</InputLabel>
            <Select
              value={orderType}
              label="نوع الزبون"
              onChange={(e) => {
                setOrderType(e.target.value);
                setOtherCustomerType("");
              }}
            >
              <MenuItem value="project_hotel">مشروع - فندق</MenuItem>
              <MenuItem value="project_restaurant">مشروع - مطعم</MenuItem>
              <MenuItem value="project_cafe">مشروع - كافيه</MenuItem>
              <MenuItem value="project_salon">مشروع - صالون</MenuItem>
              <MenuItem value="project_clinic">مشروع - عيادة</MenuItem>
              <MenuItem value="engineer_designer">مهندس أو مصمم</MenuItem>
              <MenuItem value="engineering_company">
                شركة هندسية أو شركة تصميم داخلي
              </MenuItem>
              <MenuItem value="other_company">شركات أخرى</MenuItem>
              <MenuItem value="apartment">شقة</MenuItem>
              <MenuItem value="house">بيت</MenuItem>
            </Select>
          </FormControl>

          {orderType === "other_company" && (
            <TextField
              fullWidth
              label="اذكر نوع الزبون"
              value={otherCustomerType}
              onChange={(e) => setOtherCustomerType(e.target.value)}
              sx={{ mb: 2 }}
              required
            />
          )}

          <FormControl fullWidth sx={{ mb: 2 }} required>
            <InputLabel>من أين أتى الطلب؟</InputLabel>
            <Select
              value={source}
              onChange={(e) => setSource(e.target.value)}
              label="من أين أتى الطلب؟"
            >
              <MenuItem value="سوشال ميديا">سوشال ميديا</MenuItem>
              <MenuItem value="مجمع البروج - صروح A">مجمع البروج - صروح A</MenuItem>
              <MenuItem value="مجمع البروج - صروح D">مجمع البروج - صروح D</MenuItem>
              <MenuItem value="مجمع النسيم">مجمع النسيم</MenuItem>
              <MenuItem value="الريف كافيه - بغداد">الريف كافيه - بغداد</MenuItem>
              <MenuItem value="الريف كافيه - اربيل">الريف كافيه - اربيل</MenuItem>
              <MenuItem value="ارت تاتش">ارت تاتش</MenuItem>
              <MenuItem value="علاقات ومعارف">علاقات ومعارف</MenuItem>
              <MenuItem value="ميثم برحيه">علاقات ومعارف – ميثم برحيه</MenuItem>
              <MenuItem value="نواف">علاقات ومعارف – نواف</MenuItem>
              <MenuItem value="ست سارة">ست سارة</MenuItem>
            </Select>
          </FormControl>

          {(source === "ارت تاتش" || source === "ميثم برحيه") && (
            <TextField
              fullWidth
              label="رقم الزبون"
              value={customerPhone}
              onChange={(e) => setCustomerPhone(e.target.value)}
              sx={{ mb: 2 }}
              required
            />
          )}

          <Divider sx={{ my: 1.5 }} />

          <FormControl component="fieldset" sx={{ mb: 2 }}>
            <Typography sx={{ mb: 1 }}>⚙️ هل يتطلب تركيب؟</Typography>
            <RadioGroup
              row
              value={withAssembly}
              onChange={(e) => setWithAssembly(e.target.value === "true")}
            >
              <FormControlLabel value="true" control={<Radio />} label="مع تركيب" />
              <FormControlLabel value="false" control={<Radio />} label="بدون تركيب" />
            </RadioGroup>
          </FormControl>

          <FormControl component="fieldset" sx={{ mb: 2 }}>
            <Typography sx={{ mb: 1 }}>🎨 هل يتطلب رسم؟</Typography>
            <RadioGroup
              row
              value={withDrawing}
              onChange={(e) => {
                const val = e.target.value === "true";
                setWithDrawing(val);
                if (val) setHalimaOpen(true);
              }}
            >
              <FormControlLabel value="true" control={<Radio />} label="مع رسم" />
              <FormControlLabel value="false" control={<Radio />} label="بدون رسم" />
            </RadioGroup>
          </FormControl>

          {withDrawing === true && (
            <>
              <TextField
                fullWidth
                label="عدد لوحات الرسم"
                type="number"
                value={drawingBoardsCount}
                onChange={(e) => setDrawingBoardsCount(e.target.value)}
                sx={{ mb: 2 }}
                required
                inputProps={{ min: 1, step: 1 }}
              />

              <Button
                variant="outlined"
                fullWidth
                onClick={() => setHalimaOpen(true)}
              >
                📨 رفع صور + ملاحظة للرسام (إجباري)
              </Button>

              {halimaImageUrls.length > 0 && (
                <Typography sx={{ mt: 1 }} fontSize={13} color="green">
                  ✅ تم رفع {halimaImageUrls.length} صورة للرسام
                </Typography>
              )}
            </>
          )}

          <TextField
            fullWidth
            label="ملاحظات (اختياري)"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            sx={{ mt: 2 }}
            multiline
            rows={2}
          />

          <Box mt={2}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => setIsInvoiceOpen(true)}
            >
              🧾 فتح / تعديل الفاتورة
            </Button>

            {invoiceData && (
              <Typography sx={{ mt: 1 }} fontSize={13} color="green">
                ✅ تم حفظ الفاتورة داخل التحويل
              </Typography>
            )}
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setOpenConvert(false);
              resetForm();
            }}
          >
            إلغاء
          </Button>

          <Button
            variant="contained"
            onClick={handleConvert}
            disabled={isSubmitting}
            startIcon={
              isSubmitting ? <CircularProgress size={18} color="inherit" /> : null
            }
          >
            {isSubmitting ? "جاري التحويل..." : "✅ حفظ وتحويل"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================= Halima Dialog ================= */}
      <Dialog
        open={halimaOpen}
        onClose={() => setHalimaOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          إرسال صور الرسم إلى الرسام
          <IconButton
            aria-label="close"
            onClick={() => setHalimaOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <TextField
            fullWidth
            label="ملاحظات للرسام"
            value={halimaNote}
            onChange={(e) => setHalimaNote(e.target.value)}
            multiline
            rows={3}
            sx={{ mb: 2 }}
            required
          />

          <Button variant="outlined" component="label" sx={{ mb: 2 }}>
            📤 رفع صور
            <input
              hidden
              multiple
              type="file"
              accept="image/*"
              onChange={(e) => appendPickedFiles(e, setHalimaImages)}
            />
          </Button>

          <UploadPreview files={halimaImages} onChange={setHalimaImages} />

          {halimaImages.length === 0 && (
            <Typography fontSize={13} color="error">
              * لازم تختار صورة واحدة على الأقل
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleUploadToHalima}
            disabled={uploading}
            variant="contained"
            startIcon={
              uploading ? <CircularProgress size={20} color="inherit" /> : null
            }
          >
            {uploading ? "جاري الرفع..." : "✅ حفظ صور الرسام"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="info" variant="filled">
          ✅ تم رفع صور وملاحظة الرسام بنجاح
        </Alert>
      </Snackbar>

      {/* Invoice Modal */}
      <InvoiceModal
        isOpen={isInvoiceOpen}
        onClose={() => setIsInvoiceOpen(false)}
        onSave={(data) => setInvoiceData(data)}
        existingData={invoiceData}
      />
    </Container>
  );
}
